export default [
  {
    position: "Software Engineer",
    company: "Playtech",
    fromTo: "Sep 2022 - Now",
    duration: new Date().getFullYear() - 2022 + " + years",
    responsibility:
`Contributed to a large, mature product with an 11-year development history. Worked in teams of varying sizes—up to 30–40 developers—and collaborated with different engineering and product managers.

Key contributions:
* Implemented new product features.
* Diagnosed and fixed bugs across the existing codebase.
* Improved automated test coverage and product reliability.
* Adapted to changing team structures, priorities, and management styles.
* Collaborated effectively within a large, cross-functional development environment.
    `,
    skills: "JS, React, Redux, HTML, CSS",
  },
  {
    position: "Senior Frontend Developer",
    company: "1+1 media",
    fromTo: "Jul 2021 - Apr 2022",
    duration: "10 months",
    responsibility: `A project is 4 years old. I was only one Front End developer other
                     were fullstack (java-react). My main responsibilities were feature
                     development, refactoring, bug fix. 65% of all tasks I've created on
                     my own. That was mostly ui, logical, code structure issues. The
                     company encouraged it.`,
    skills: "React, MobX",
  },
  {
    position: "Software Engineer",
    company: "Playtech",
    fromTo: "Aug 2019 - Apr 2021",
    duration: "1 year 9 months",
    responsibility: "I've worked on client side (configuration, branding, support, upgrade, bugfix).",
    skills: "JS, React, HTML, CSS",
  },
  {
    position: "Front End Developer",
    company: "Astound Commerce",
    fromTo: "Sep 2018 - Jun 2019",
    duration: "10 months",
    responsibility: "I’ve taken a part in develop two e-commerce projects(bugfix, brought new functionality).",
    skills: "JS, GitLab, Node.js, NPM, Jira",
  },
  {
    position: "Full Stack Developer",
    company: "Itera",
    fromTo: "Sep 2017 - Jun 2018",
    duration: "10 months",
    responsibility: "I’ve taken a part in developing server & client side for Íslandsbanki (bugfix, tests, brought new functionality).",
    skills: "JS, Java 8, Angular.js, Node.js, Spring, Camel, REST, JSON, SoapUI, JUnit, HTML, CSS, bakckbase, BackbaseAndroid Studio, IntelliJ IDEA"
  },
  {
    position: "Full Stack Developer",
    company: "Kyiv Smart City",
    fromTo: "Jun 2016 - Jyl 2017",
    duration: "1 year 1 months",
    responsibility: "I've taken a part in develop iGov and pdf editor online (bugfix, brought new functionality).",
    skills: "JS, Java, Node.js, Angular JS 1.5, Git, Jira, React, Redux, JQuery, JSON, HTML, CSS, Bootstrap",
  },
  {
    position: "Java Developer",
    company: "Big Fish Game",
    fromTo: "May 2015 - Jun 2016",
    duration: "1 year 2 months",
    responsibility: "I've taken a part in develop product that worked with Facebook API (bugfix, tests, brought new functionality)",
    skills: "Java, Spring MVC, MySql, PostgreSQL, Mongo, ActiveJdbc, Hibernate 4, REST, Jersey",
  }
];